import { Component, AfterViewChecked, AfterViewInit, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {ConfigService} from '../../../../services/config.service';
import {LicenseService} from '../../../../services/license.service';
import {NotificationService} from '../../../../services/notification.service';


@Component({
    selector: 'itpx-evaluation-ebook',
    templateUrl: './ebook.component.html',
    styleUrls: ['./ebook.component.css']
})

export class EvaluationEBookComponent implements AfterViewChecked, AfterViewInit, OnInit {
    private fileUrl: string;

    private sub: any;

    constructor(
        private route: ActivatedRoute,
        private configService: ConfigService,
        private licenseService: LicenseService,
        private notificationService: NotificationService,
        private http: Http
    ) {
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.startPlayer(params['deliverableId']);
        });
    }
    
    ngAfterViewInit() {
        // this.sub = this.route.params.subscribe(params => {
        //     this.startPlayer(params['deliverableId']);
        // });
    }

    ngAfterViewChecked() {

    }

    startPlayer(deliverableId: string) {
        console.log(deliverableId);
        var self = this;
        this.licenseService.getEvaluationEBookFileUrl(deliverableId)
            .subscribe(
            body => {
                self.fileUrl = body.data;
            },
            error => self.handleError
            )

    }

    private handleError(error: any) {
        this.notificationService.error(error, 'Failed');
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/ebook/ebook.component.ts